
export const FETCH_IMAGE_NAMES = "FETCH_IMAGE_NAMES";
export const FETCH_IMAGE_NAMES_SUCCESS = "FETCH_IMAGE_NAMES_SUCCESS";
export const FETCH_IMAGE_NAMES_FAILURE = "FETCH_IMAGE_NAMES_FAILURE";

export const fetchImageNames = () => {
  return {
    type: FETCH_IMAGE_NAMES,
    info: '[FETCH IMAGE NAMES]',
  };
}


export const fetchImageNamesSuccess = data => {
  return {
    type: FETCH_IMAGE_NAMES_SUCCESS,
    info: '[FETCH IMAGE NAMES SUCCESS]',
    payload: {
      data
    }
  };
}

export const fetchImageNamesError = error => {
  return {
    type: FETCH_IMAGE_NAMES_FAILURE,
    info: '[FETCH IMAGE NAMES FAILURE]',
    payload: {
      error
    }
  };
}

// export const fetchImageNames = createAsyncThunk("image/fetchImageNames", async () => {
//     try {
//         const response = await axios.get('http://localhost:3001/images', this.config).then(response => {
//             console.log('files', response);
//         });
//         return response.data.files;
//     }catch(e) {
//         return e.message;
//     }
// }) 
// const imageSlice = createSlice({
//     name: 'image',
//     initialState,
//     extraReducers: builder => {
//       builder.addCase(fetchImageNames.pending, state => {
//         state.loading = true;
//       });
      
//       builder.addCase(fetchImageNames.fulfilled, (state, action) => {
//         state.loading = false;
//         state.images = action.payload;
//         state.error = '';
//       });
   
//       builder.addCase(fetchImageNames.rejected, (state, action) => {
//         state.loading = false;
//         state.images = [];
//         state.error = action.error.message;
//       });
//     },
//     reducers: {
//         load: (state, action) => {
//             state.images = action.payload
//         },
//     }
// })

// export const imageNames = (state) => state.images;
// export const imageStatus = (state) => state.loading;
// export const imageError = (state) => state.error;
